import { CurrencyDollarIcon } from "@phosphor-icons/react/dist/csr/CurrencyDollar";
import { useMemo } from "react";
import {
  MaskedFormInput,
  type MaskedFormInputProps,
} from "@volca/ui/components/ui/masked-form-input";
import { getValidDollarAmountMask } from "@volca/ui/masks";

export interface MoneyInputProps
  extends Omit<MaskedFormInputProps, "maskOptions"> {
  includeDollarSymbol?: boolean;
}

export const MoneyInput = ({
  value,
  onChange,
  startAdornment = <CurrencyDollarIcon />,
  includeDollarSymbol = false,
  ...props
}: MoneyInputProps) => {
  const maskOptions = useMemo(
    () => getValidDollarAmountMask(includeDollarSymbol),
    [includeDollarSymbol],
  );

  return (
    <MaskedFormInput
      value={value}
      onChange={onChange}
      startAdornment={startAdornment}
      maskOptions={maskOptions}
      {...props}
    />
  );
};
